<template>
    <v-card-text>
        <h3>Configuração de cotas disponíveis para reserva</h3>
        <v-form ref="formConfigCotasDisponiveis">
            <v-row style="margin-top: 25px" class="d-flex align-center">
                <v-col cols="12" md="4">
                    <m-text-field

                            label="Quantidade de cotas disponíveis para reservar:"
                            class="required"
                            outlined
                            v-input-filter="[$filters.numeric]"
                            v-model="localQuantidadeCotasReservar"
                            maxlength="3"
                            :rules="[$rules.required, (value) => value > 0 ? true : 'O valor deve ser maior que 0']"
                    />
                </v-col>
                <v-col cols="12" md="6" class="mt-5">
                    <v-switch class="px-0"
                              fluid v-model="localLimiteCotasParaReservarAtivo" label="Habilitar/Desabilitar"></v-switch>
                </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="salvarConfiguracao">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-card-text>
</template>

<script>
  import { AlertTypes } from '../../plugins/alerts_types'
  import { notification } from '../../plugins/helpers'

  export default {
    name: 'ConfiguracaoLimiteCotasReserva',
    props: {
      limiteCotasParaReservarAtivo: {
        type: Boolean,
        default: false
      },
      quantidadeCotasReservar: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        localLimiteCotasParaReservarAtivo: this.limiteCotasParaReservarAtivo,
        localQuantidadeCotasReservar: this.quantidadeCotasReservar
      }
    },
    watch: {
      localLimiteCotasParaReservarAtivo (newValue) {
        this.$emit('update:limiteCotasParaReservarAtivo', newValue)
      },
      localQuantidadeCotasReservar (newValue) {
        this.$emit('update:quantidadeCotasReservar', newValue)
      },
      limiteCotasParaReservarAtivo (newValue) {
        this.localLimiteCotasParaReservarAtivo = newValue
      },
      quantidadeCotasReservar (newValue) {
        this.localQuantidadeCotasReservar = newValue
      }
    },
    methods: {
      async salvarConfiguracao () {
        if (!this.$refs.formConfigCotasDisponiveis.validate()) {
          return
        }
        try {
          await this.$http.put('/painel/limite_cotas_reservar', {
            limite_cotas_para_reservar_ativo: this.localLimiteCotasParaReservarAtivo,
            quantidade_cotas_reservar: this.localQuantidadeCotasReservar
          })
          notification(AlertTypes.SUCCESS, 'Quantidade de cotas disponíveis para reserva atualizado com sucesso!')
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível atualizar a quantidade de cotas disponíveis no momento, tente novamente e se o problema persistir, entre em contato com a Área de Suporte.')
        }
      }
    }
  }
</script>

<style scoped>
/* Adicione qualquer estilo necessário aqui */
</style>
